import React from "react";

interface DocStepIndicatorProps {
  number: number;
  size?: "small" | "large";
  className?: string;
}

export default function DocStepIndicator({
  number,
  size = "small",
  className = "",
}: DocStepIndicatorProps) {
  const sizeClasses = {
    small: "w-6 h-6 text-sm",
    large: "w-8 h-8",
  };

  return (
    <span
      className={`bg-blue-600 text-white rounded-full flex items-center justify-center font-semibold mr-3 mt-0.5 flex-shrink-0 ${sizeClasses[size]} ${className}`}
    >
      {number}
    </span>
  );
}
